export default {"src":"/_next/static/media/0x4fabb145d64652a948d72533023f6e7a623c7c53.cf54c71c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};